import { FC, ReactNode } from 'react';
import RedesignThemeProvider from '../../RedesignThemeProvider';
import { AuthLogo } from './AuthLogo';
import { useAuthLayoutStyles } from './AuthLayout.styles';
import { MediaPanel } from './MediaPanel';

interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  const cls = useAuthLayoutStyles();

  return (
    <RedesignThemeProvider>
      <div className={cls.layout}>
        <div className={cls.panel}>
          <div className={cls.panelInner}>
            <div className={cls.logoWrap}>
              <AuthLogo />
            </div>
            <div className={cls.contentInner}>{children}</div>
          </div>
        </div>
        <MediaPanel />
      </div>
    </RedesignThemeProvider>
  );
};
